<script>
import FeaturesSection from "../../components/projects/detailed/FeaturesSection";
import GallerySection from "../../components/projects/detailed/GallerySection";
import LocationSection from "../../components/projects/detailed/LocationSection";
import QuoteSection2 from "../../components/projects/detailed/QuoteSection2";
import ContactFormSection from "../../components/projects/detailed/ContactFormSection";

import Vue from 'vue';


Vue.component('featuressection', FeaturesSection);
Vue.component('quotesection2', QuoteSection2);
Vue.component('gallerysection', GallerySection);
Vue.component('locationsection', LocationSection);
Vue.component('contactformsection', ContactFormSection);

export default {
  template:"#vue-project-single2",
  name: "projectSingle",
  components: {
    ContactFormSection,
    QuoteSection2,
    LocationSection,
    GallerySection,
    FeaturesSection,
  },
  props: {
      project_id:Number,
      project_backend:Object
  },
  data: () => ({
    models: [],
    src_map: "",
    floor_medias: [],
    project: {
      medias: [],
      projectcontactsquery: [],
    },
  }),
  
  mounted() {
    this.setProject();
  },
  methods: {
    openModalPromotions() {
      this.$emit('open');
    },
    setProject(){
        this.project = this.project_backend;
        var zoom = 14;
        var mapScale = 591657550.5 / Math.pow(2, zoom + 1);
        var base64 = btoa([this.project.latitude, this.project.longitude]);
        this.src_map =
        "https://www.google.com/maps/embed?key=asdfsdfsf&pb=!1m7!1m2!1m1!1d" +
        mapScale +
        "!3m3!1m2!1s0!2z" +
        base64;

        this.models = this.project.floormediasgrouped;
    },
  },
};
</script>

<style>
@media (max-width: 769px) {
.section-widget{
    padding: 25px !important;
  }
}
</style>
<style scoped>
@media (max-width: 768px) {
  .map-nav-item {
    display: none !important;
  }
}

@media (max-width: 959px) {
  .map-nav-item {
    display: none !important;
  }
}
</style>
